import { CONSTRUCTION_AUTODESK_URL } from '../../../helpers/const';
export const HELP_LINK = "".concat(CONSTRUCTION_AUTODESK_URL, "/support");
export const LEARNING_CENTER_URL_1 = 'https://learnacc.autodesk.com';
export const LEARNING_CENTER_URL_2 = "".concat(CONSTRUCTION_AUTODESK_URL, "/why-autodesk-construction-cloud");
//# sourceMappingURL=const.js.map